const INITIAL_STATE = {
  data: {},
  errors: {},
            
}
const printInvoice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'PRINT_INVOICE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'PRINT_INVOICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
            
export default printInvoice;